// libs
import React, { memo } from 'react';

// styles
import { AccountButton } from './styles';

// hooks
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// constants
import { MY_ACCOUNT } from 'shared/constants/uri';

const ARIA_LABELS = {
  VIEW_ACCOUNT: 'View account',
};

function Account() {
  const AccountIcon = useStoreIcon(IconName.USER);

  const goToAccount = () => {
    window.location.href = MY_ACCOUNT;
  };

  const keyboardProps = useKeyboardClick(goToAccount);

  return (
    <AccountButton
      {...keyboardProps}
      aria-label={ARIA_LABELS.VIEW_ACCOUNT}
      data-at="account-button"
    >
      <AccountIcon aria-hidden="true" />
    </AccountButton>
  );
}

export default memo(Account);
